/**
 * @generated SignedSource<<2bd0f4b0f83f683c4d7f2afdd602965c>>
 * @relayHash 0e1186086ad3f6fc22ae60ab68229332
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c8eccfcc894ee9d344073e0e927e248c9d937f980faba1c91868196bae93c60e

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpCenterMediaConfigOperationType = "BANNER_UPLOAD" | "LOGO_UPLOAD" | "READ" | "%future added value";
export type hubHomeContentWrapperQuery$variables = {
  cloudId: string;
  hubAri: string;
  hubEditMode: boolean;
  operationType?: HelpCenterMediaConfigOperationType | null | undefined;
  pageAri: string;
};
export type hubHomeContentWrapperQuery$data = {
  readonly helpCenter: {
    readonly " $fragmentSpreads": FragmentRefs<"hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference" | "hubHomeContent_AtlassianHubHome_HubInfo">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference">;
};
export type hubHomeContentWrapperQuery = {
  response: hubHomeContentWrapperQuery$data;
  variables: hubHomeContentWrapperQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubEditMode"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "operationType"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageAri"
},
v5 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "type"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = [
  {
    "kind": "ScalarField",
    "name": "default"
  }
],
v9 = {
  "kind": "Variable",
  "name": "operationType",
  "variableName": "operationType"
},
v10 = [
  {
    "kind": "ScalarField",
    "name": "asapIssuer"
  },
  {
    "kind": "ScalarField",
    "name": "mediaCollectionName"
  },
  {
    "kind": "ScalarField",
    "name": "mediaToken"
  },
  {
    "kind": "ScalarField",
    "name": "mediaUrl"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "hubHomeContentWrapperQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "hubHomeContent_AtlassianHubHome_HubInfo"
          },
          {
            "kind": "FragmentSpread",
            "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference"
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "hubHomeContentWrapperQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "helpCenterAri",
                "variableName": "hubAri"
              }
            ],
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "hoistedProjectKey"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "slug"
                  },
                  {
                    "alias": "allPages",
                    "concreteType": "HelpCenterPage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "concreteType": "HelpCenterPageName",
                        "kind": "LinkedField",
                        "name": "name",
                        "plural": false,
                        "selections": (v8/*: any*/)
                      },
                      {
                        "concreteType": "HelpCenterPageDescription",
                        "kind": "LinkedField",
                        "name": "description",
                        "plural": false,
                        "selections": (v8/*: any*/)
                      }
                    ]
                  },
                  (v6/*: any*/),
                  {
                    "alias": "currentPage",
                    "args": [
                      {
                        "fields": [
                          {
                            "items": [
                              {
                                "kind": "Variable",
                                "name": "ids.0",
                                "variableName": "pageAri"
                              }
                            ],
                            "kind": "ListValue",
                            "name": "ids"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "filter"
                      }
                    ],
                    "concreteType": "HelpCenterPage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "concreteType": "HelpCenterPageLayout",
                        "kind": "LinkedField",
                        "name": "pageLayout",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "HelpCenterLayoutAdf",
                            "kind": "LinkedField",
                            "name": "layoutAdf",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "HelpCenterLayoutAdfContentConnection",
                                "kind": "LinkedField",
                                "name": "content",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "HelpCenterLayoutAdfContentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "HelpCenterLayoutAdfContent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "content"
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "HelpCenterBranding",
                    "kind": "LinkedField",
                    "name": "helpCenterBranding",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "HelpCenterLogo",
                        "kind": "LinkedField",
                        "name": "logo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "fileId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "url"
                          }
                        ]
                      },
                      {
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "primary"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "HelpCenter"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  }
                ],
                "type": "QueryError"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v7/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "ari",
                "variableName": "hubAri"
              },
              (v9/*: any*/)
            ],
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "hubMediaConfig",
            "plural": false,
            "selections": (v10/*: any*/)
          },
          {
            "alias": "pageMediaConfig",
            "args": [
              {
                "kind": "Variable",
                "name": "ari",
                "variableName": "pageAri"
              },
              (v9/*: any*/)
            ],
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "hubMediaConfig",
            "plural": false,
            "selections": (v10/*: any*/)
          }
        ]
      },
      {
        "condition": "hubEditMode",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "items": [
                  {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                  }
                ],
                "kind": "ListValue",
                "name": "cloudIds"
              }
            ],
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "cloudUrl"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c8eccfcc894ee9d344073e0e927e248c9d937f980faba1c91868196bae93c60e",
    "metadata": {},
    "name": "hubHomeContentWrapperQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6ed9b0f70a74a695529816effcd8e57b";

export default node;
